import { instanceEmployee } from '../../../../services/instances';
import type { AssignHiringOrgpathModel, AssignHiringOrgpathResponse, EditEmployeeOrgpathModel, EditEmployeeOrgpathResponse } from '../types/hooks';

const getHiringOrgpath = async (params: Record<string, any> = {}): Promise<any> => {
    const response = await instanceEmployee.get<any>('/hiring_orgpath', { params });
    return response.data.data;
};

const assignHiringOrgpath = async (data: AssignHiringOrgpathModel): Promise<AssignHiringOrgpathResponse> => {
    const response = await instanceEmployee.post<AssignHiringOrgpathResponse>('/orgpath', data);
    return response.data;
};

const updateHiringOrgpath = async (data: EditEmployeeOrgpathModel): Promise<EditEmployeeOrgpathResponse> => {
    const response = await instanceEmployee.patch<EditEmployeeOrgpathResponse>('/orgpath', data);
    return response.data;
};

export { getHiringOrgpath, assignHiringOrgpath, updateHiringOrgpath };
